@if (isLoading) {
    <div class="reserve-loading-container">
      <div class="loading-container"></div>
      <span>載入預約資料中．．．</span>
    </div>
  } @else {
    <!-- 準備指南 -->
    @if (selectedTab === 0) {

      <!--健檢行事曆-->
      <div class="reserve-confirm-content">
        <div class="page-subtitle-block">
          <img
            width="24"
            height="24"
            ngSrc="assets/img/mailbox.png"
            alt="clock-user"
          />
          <div>
            <p class="subTitle-main"> {{ 'my-reservation.you-have-reservation-subtitle' | translate }} </p>
            <p class="subTitle-secondary"> {{ 'my-reservation.you-have-reservation-subtitle-2' | translate }} </p>
          </div>
        </div>
        <div
          class="card-content register-card-content appointment-complete-calendar"
        >
          <h3 class="register-card-title">
            {{ 'my-reservation.below-is-your-calendar' | translate }}
          </h3>
          <div class="input-block">
            <div class="complete-calendar-progress"></div>
            <div class="complete-calendar-time">
              @for (reminder of healthCheckPlan?.reminders?.slice()?.reverse(); track $index) {
                <div class="complete-calendar-block">
                  <div class="complete-calendar-block-date">
                    {{ reminder.date.slice(-5) }}
                  </div>
                  <ul class="complete-calendar-block-list">
                    @for (desc of reminder.textList; track $index) {
                      <li [innerHTML]="desc"></li>
                    }
                  </ul>
                </div>
              }
            </div>
          </div>
        </div>

        <!-- 分隔線 -->
        <div class="section-divider"></div>

        <!--檢前提醒-->
        <div
          class="card-content register-card-content appointment-complete-reminder"
        >
          <h3 class="register-card-title">
            {{ 'my-reservation.your-exam-reminder' | translate }}
          </h3>
            
          @if ((healthCheckPlan?.reminderList?.length ?? 0) > 0) {
            @for (reminderItem of healthCheckPlan?.reminderList; let i = $index; track i) {
              <div class="input-block" [class.active]="isReminderActive(reminderItem)">
                  <div class="reminder-title" (click)="toggleReminderActive(reminderItem)">
                      <p>{{ reminderItem.examNameList }}</p>
                      <img
                          width="24"
                          height="24"
                          alt=""
                          [ngSrc]="
                              isReminderActive(reminderItem)
                                  ? 'assets/img/i-arrow-up.svg'
                                  : 'assets/img/i-arrow-down.svg'
                          "
                      />
                  </div>
                  <div class="reminder-body">
                      <p [innerHTML]="reminderItem.reminderText"></p>
                  </div>
              </div>
            }
          } @else {
            <div class="input-block">
                <p>無提醒事項</p>
            </div>
          }
        </div>
      </div>
  }
   <!-- 檢查項目  -->
  @else if (selectedTab === 1) {
    <!--檢查方案-->
    <div class="register-card-content">
      <div class="register-card-title-block">
        <h3 class="register-card-title exam-plan-title">
          {{ selectedPackage }}
        </h3>
        @if (isShowModifyAddExam) {
          <button mat-button (click)="modifyExam()" class="btn-text-primary">
            <div>
              <img
                width="20"
                height="20"
                ngSrc="assets/img/Edit.png"
                alt=""
              />
              {{ 'my-reservation.modify-exam' | translate }}
            </div>
          </button>
        }
      </div>

      @if (isPersonal) {
        <!-- 應付金額 -->
        <div class="confirm-body">
          <div class="confirm-body-item">
              <p class="confirm-body-item-title">
                {{ 'my-reservation.payment-amount' | translate }}
              </p>
              <p>
                <label>$</label
                >{{ healthCheckPlan?.packageGroup?.selfAmt | numberComma }}
              </p>
          </div>
        </div>
      } @else {
        <!-- 企業套檢金額 -->
        <!-- 當應付金額大於0時,才顯示總金額 -->
        <!-- @if (Number(healthCheckPlan?.packageGroup?.selfAmt) > 0) {
          <div class="confirm-body">
            <div class="confirm-body-item">
              <p class="confirm-body-item-title">
                {{ 'my-reservation.total-amount' | translate }}
              </p>
              <p>
                <label>$</label>
                {{ healthCheckPlan?.packageGroup?.billAmt | numberComma }}
              </p>
            </div>
          </div>
        } -->
          <!-- 2026/05/13 由 Jon決定隱藏 企業補助金額 -->
        <!-- @if (hasSponsorAmt && Number(healthCheckPlan?.packageGroup?.selfAmt) > 0){ -->
          <!-- 企業補助金額 -->
          <!-- <div class="confirm-body">
            <div class="confirm-body-item">
                <p class="confirm-body-item-title">
                  {{ 'my-reservation.company-sponsorAmt' | translate }}
                </p>
                <p>
                  <label>$</label
                  >{{ healthCheckPlan?.packageGroup?.sponsorAmt | numberComma }}
                </p>
            </div>
          </div>
        } -->
        <!-- 應付金額 -->
        <div class="confirm-body">
          <div class="confirm-body-item">
              <p class="confirm-body-item-title">
                {{ 'my-reservation.payment-amount' | translate }}
              </p>
              <p>
                <label>$</label>
                @if (Number(healthCheckPlan?.packageGroup?.selfAmt) < 0) {
                  0
                } @else {
                  {{ healthCheckPlan?.packageGroup?.selfAmt | numberComma }}
                }
              </p>
          </div>
        </div>
      }

      <div class="confirm-body">
        <div class="confirm-body-item">
          <p class="confirm-body-item-title">
            {{ 'my-reservation.estimated-exam-time' | translate }}
          </p>
          <p>
            {{ getDayTypeText(healthCheckPlan?.packageGroup?.dayType)
            }}{{ 'my-reservation.exam' | translate }}
          </p>
        </div>
      </div>
      <!-- @if (showFullExamInfos) { -->
        <!--方案檢項-->
        <div class="confirm-body plan-item">
          <!-- 已選方案-->
          <!-- <div class="confirm-body-item confirm-plan-item">
            <p class="confirm-plan-item-title">
              {{ selectedPackage }}
            </p>
          </div> -->

          <div class="reserve-confirm-cart-item">
            @for (
              examNameDeptName of examNameGroupByDeptName.entries();
              let i = $index;
              track i
            ) {
              <div
                class="reserve-confirm-cart-item-title"
                (click)="
                  isDeptNameOpen.set(
                    examNameDeptName[0],
                    !isDeptNameOpen.get(examNameDeptName[0])
                  )
                "
              >
                <h4>{{ examNameDeptName[0] }}</h4>
                <button mat-button class="btn-icon">
                  <img
                    width="24"
                    height="24"
                    alt=""
                    [ngSrc]="
                      isDeptNameOpen.get(examNameDeptName[0])
                        ? 'assets/img/i-arrow-up.svg'
                        : 'assets/img/i-arrow-down.svg'
                    "
                  />
                </button>
              </div>
              @if (isDeptNameOpen.get(examNameDeptName[0])) {
                <div class="reserve-confirm-cart-item-block">
                  @for (
                    examName of examNameDeptName[1];
                    let j = $index;
                    track j
                  ) {
                    <div class="reserve-confirm-cart-checked-item">
                      <div>
                        <button
                          mat-icon-button
                          type="button"
                          class="btn-icon btn-info"
                          (click)="showExamDialog(getExamInfoByName(examName))"
                        >
                          <img
                            width="14"
                            height="14"
                            ngSrc="assets/img/i-info.svg"
                            alt=""
                          />
                        </button>
                        <p>{{ examName }}</p>
                      </div>
                    </div>
                  }
                </div>
              }
            }
          </div>
        </div>
        <!--加購檢項-->
        @if (addExamNameList.length > 0) {
          <div class="confirm-body">
            <div class="confirm-body-item confirm-plan-item">
              <h3 class="register-card-title add-exam-title">
                {{ 'my-reservation.add-exam-item' | translate }}
              </h3>
            </div>

            <div class="reserve-confirm-cart-item add-item">
              @for (addExamName of addExamNameList; track $index) {
                <div class="reserve-confirm-cart-checked-item">
                  <div>
                    <button
                      mat-icon-button
                      type="button"
                      class="btn-icon btn-info"
                      (click)="showExamDialog(getExamInfoByName(addExamName))"
                    >
                      <img
                        width="14"
                        height="14"
                        ngSrc="assets/img/i-info.svg"
                        alt=""
                      />
                    </button>
                    <p>{{ addExamName }}</p>
                  </div>
                  <p class="reserve-confirm-add-cart-item">
                    <label>$ {{ getExamPriceByName(addExamName) | numberComma }}</label> 
                  </p>
                </div>
              }
            </div>
          </div>
        }
    <!-- } -->

    <!-- 查看完整檢項 -->
    <!-- <button mat-button class="btn-text-primary btn-size-m"
        (click)="toggleShowFullExamInfos()">
        <div>
          <span>{{ (showFullExamInfos ? 'my-reservation.collapse-exam-items' : 'my-reservation.expand-to-view-exam-items') | translate }}</span>
          <img
            [ngSrc]="showFullExamInfos? 'assets/img/i-minus.svg' : 'assets/img/i-add.svg'"
            width="12"
            height="12"
            alt="toggle icon"
          />
        </div>
    </button> -->
    </div>
  } @else {
    <!--預約資訊-->
    <div class="register-card-content reserve-info">
      <div class="register-card-title-block">
        <h3 class="register-card-title reserve-info-title">
          {{ 'my-reservation.reserve-info' | translate }}
        </h3>
        @if (isShowCancelReservation) {
          <button
            mat-button
            (click)="cancelReservation()"
            class="btn-text-primary"
          >
            <div>
              {{ 'my-reservation.cancel-reservation' | translate }}
            </div>
          </button>
        }
      </div>
      <!--預約資料-->
      <!-- <div class="confirm-header">
        <h4 class="confirm-header-title">
          {{ 'my-reservation.reserve-data' | translate }}
        </h4>
        @if (isShowModifyTime) {
          <button
            mat-button
            class="btn-icon"
            (click)="navigateToAppointmentTime()"
          >
            <img
              width="20"
              height="20"
              ngSrc="/assets/img/i-pencil-dark.svg"
              alt=""
            />
          </button>
        }
      </div> -->
      <!-- <div class="confirm-body">
        <div class="confirm-body-item">
          <p class="confirm-body-item-title">
            {{ 'my-reservation.health-check' | translate }}
          </p>
          <p>{{ healthCheckTime }}</p>
        </div>
        @if(isShowNutrition){
        <div class="confirm-body-item">
          <p class="confirm-body-item-title">
            {{ 'my-reservation.nutrition-consultation' | translate }}
          </p>
          <p>{{ nutritionConsultationTime }}</p>
        </div>
      } -->
        <!-- @for (imageItem of imageItems; track $index) {
          <div class="confirm-body-item">
            <p class="confirm-body-item-title">{{ imageItem.imageExamName }}</p>
            <p>
              @if(imageItem.imageBookDateTime){ 
                {{ imageItem.imageBookDateTime }} 
              } @else {
              {{ 'my-reservation.someone-call-to-confirm-time' | translate }}
              }
            </p>
          </div>
        }
        <div class="confirm-body-item">
          <p class="confirm-body-item-title">
            {{ 'my-reservation.exam-center' | translate }}
          </p>
          <p >{{ orgName }}</p> -->
          <!-- @if (healthCheckPlan?.isModified) {
            <button mat-button class="btn-icon" (click)="navigateToReserveLocation()">
              <img width="20" height="20" ngSrc="/assets/img/i-pencil-dark.svg" alt="" />
            </button>
          } -->
        <!-- </div>
      </div> -->

      <!--檢查相關資料與報告-->
      <div class="confirm-header">
        <h4 class="confirm-header-title">
          {{ 'my-reservation.exam-data-and-report' | translate }}
        </h4>
        @if (isShowModifyContactAddress||isShowModifyExamReport) {
          <button
            mat-button
            class="btn-icon"
            (click)="openModifyExamReportDialog()"
          >
            <img
              width="18"
              height="18"
              ngSrc="/assets/img/adjust-appointment.png"
              alt=""
            />
          </button>
        }
      </div>
      <div class="confirm-body">
        <div class="confirm-body-item confirm-body-item-mobile">
          <p class="confirm-body-item-title confirm-body-item-title-mobile">
            {{ 'my-reservation.pre-exam-address' | translate }}
          </p>
          @if (
            healthCheckPlan?.bookData?.noticeSendType ===
            API_PARAMS.PRE_EXAM_INFO_DELIVERY_METHOD.AGENT.code
          ) {
            <p>{{ 'my-reservation.pick-up-by-agent' | translate }}</p>
          }@else if (
            healthCheckPlan?.bookData?.noticeSendType ===
            API_PARAMS.PRE_EXAM_INFO_DELIVERY_METHOD.NOT_INDIVIDUAL.code
            ) {
            <p>{{ 'my-reservation.not-need-to-send' | translate }}</p>
          } @else {
            <p class="confirm-body-item-content">{{ contactAddress }}</p>
          }
        </div>
        <!--承辦領取或不需寄送：顯示聯絡地址-->
        @if (
          healthCheckPlan?.bookData?.noticeSendType ===
          API_PARAMS.PRE_EXAM_INFO_DELIVERY_METHOD.AGENT.code ||
          healthCheckPlan?.bookData?.noticeSendType ===
          API_PARAMS.PRE_EXAM_INFO_DELIVERY_METHOD.NOT_INDIVIDUAL.code
        ) {
          <div class="confirm-body-item confirm-body-item-mobile">
            <p class="confirm-body-item-title confirm-body-item-title-mobile">
              {{ 'my-reservation.contact-address' | translate }}
            </p>
            <p>{{ contactAddress }}</p>
          </div>
        }
        <div class="confirm-body-item confirm-body-item-mobile">
          <p class="confirm-body-item-title confirm-body-item-title-mobile">
            {{ 'my-reservation.exam-report-delivery' | translate }}
          </p>
          @if (
            healthCheckPlan?.bookData?.deliveryType ===
            API_PARAMS.DELIVERY_METHOD.AGENT.code
          ) {
            <p>{{ 'my-reservation.pick-up-by-agent' | translate }}</p>
          } @else if (healthCheckPlan?.bookData?.deliveryType ===
          API_PARAMS.DELIVERY_METHOD.NOT_INDIVIDUAL.code ||
          healthCheckPlan?.bookData?.deliveryType ===
          API_PARAMS.DELIVERY_METHOD.OTHER.code
          ) {
            <p>{{ 'my-reservation.not-need-to-send' | translate }}</p>
          }
          @else {
            <p class="confirm-body-item-content" [innerHTML]="examReportAddress"></p>
          }
        </div>
        <!--只有當 deliveryType='0'(國內)或'9'(國外) 時才顯示收件人資料-->
        @if (
          healthCheckPlan?.bookData?.deliveryType === '0'||
          healthCheckPlan?.bookData?.deliveryType === '9'
          
        ) {
          <div class="confirm-body-item confirm-body-item-mobile">
            <p class="confirm-body-item-title confirm-body-item-title-mobile">
              {{ 'appointment-confirm.recipient' | translate }}
            </p>
            <p>{{ recipient }}
            <!-- @if(isShowRecipientCell){
              <span class='doc-divider'>・</span>
              {{ recipientCell }}
              } -->
            </p>
          </div>
        }
        <div class="confirm-body-item confirm-body-item-mobile">
          <p class="confirm-body-item-title confirm-body-item-title-mobile">
            {{ 'my-reservation.exam-language' | translate }}
          </p>
          <p>{{ reportLanguageNoDesc }}
            @if (
          reportLanguageUno === API_PARAMS.EXAM_REPORT_LANGUAGE.JAPANESE.code||reportLanguageNoDesc === '日文'
          ) {
            ({{
            'appointment-info.addition-translate-fee' | translate
            }})
          }
          </p>
          
        </div>
      </div>

      <!-- 下底線 -->
      <div class="section-divider reserve-info"></div>

      <!--健檢服-->
      <div class="confirm-header">
        <h4 class="confirm-header-title">
          {{ 'my-reservation.exam-clothes' | translate }}
        </h4>
        @if (isShowModifyExamClothes) {
          <button
            mat-button
            class="btn-icon"
            (click)="openModifyExamClothesDialog()"
          >
            <img
              width="18"
              height="18"
              ngSrc="/assets/img/adjust-appointment.png"
              alt=""
            />
          </button>
        }
      </div>
      <div class="confirm-body">
        <div class="confirm-body-item">
          <p class="confirm-body-item-title">
            {{ 'my-reservation.size' | translate }}
          </p>
          <p>{{ clothesSizeNoDesc }}</p>
        </div>
      </div>

      <!-- 下底線 -->
      <div class="section-divider reserve-info"></div>

      <!--餐食-->
      <div class="confirm-header">
        <h4 class="confirm-header-title">
          {{ 'my-reservation.diet' | translate }}
        </h4>
        @if (isShowModifyDiet) {
          <button
            mat-button
            class="btn-icon"
            (click)="openModifyDietDialog()"
          >
            <img
              width="18"
              height="18"
              ngSrc="/assets/img/adjust-appointment.png"
              alt=""
            />
          </button>
        }
      </div>

      <div class="confirm-body">
        <div class="confirm-body-item">
          <p class="confirm-body-item-title">
            {{ 'my-reservation.breakfast' | translate }}
          </p>
          <p>{{ breakfastNoDesc }}</p>
        </div>
        @if (lunchNoDesc) {
        <div class="confirm-body-item">
          <p class="confirm-body-item-title">
            {{ 'my-reservation.lunch' | translate }}
          </p>
          <p>{{ lunchNoDesc }}</p>
        </div>
        }
      </div>
    </div>
  }
}
